<template>
  <div class="lila-chart-container">
    <Line
      :data="chartData"
      :options="mergedOptions"
    />
  </div>
</template>

<script setup>
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
} from "chart.js";
import { Line } from "vue-chartjs";
import { computed } from "vue";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

const props = defineProps({
  chartData: {
    type: Object,
    required: true
  },
  options: {
    type: Object,
    default: () => ({})
  }
});

const mergedOptions = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  ...props.options
}));
</script>

<style scoped>
.lila-chart-container {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
